import client from './axiosInstance';

export const fetchTimesheetsMembersFilterList = async () => {
  return await client.get('/time-entries/members');
};

export const fetchMemberTimesheetsInfo = async (memberId: number) => {
  return await client.get(`/time-entries/members/${memberId}`);
};
